import { EventEmitter, Injectable } from '@angular/core';
import {
  ApiResponseGeneral,
  PaginatedResponse,
  Product,
} from '../models/products-model/products.model';
import { catchError, Observable, of, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GeneralService } from './general.service';
import { environment } from '../../../environments/environment';
import { LocationDetailResponse } from '../models/location-model/location.model';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  public emitProduct = new EventEmitter<Product>();
  public deleteProducts = new EventEmitter();
  public emitLocation = new EventEmitter<LocationDetailResponse>();
  public emitCont = new EventEmitter<number>();
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
    private matSnackBar: MatSnackBar,
    private generalService: GeneralService,
  ) {}

  public getSupply(params: {
    Page: number;
    PageSize: number;
    partnerId: string;
    SearchField?: string | null;
    SearchFieldValue?: string | null;
    Sort?: string;
    SortDir?: string;
    'DefaultSearchFields[0].Text'?: string;
    'DefaultSearchFields[0].Value'?: string;
  }): Observable<ApiResponseGeneral<PaginatedResponse<Product>> | null> {
    const paramsAux = this.generalService.buildParamsEncoder(params);
    return this.http
      .get<
        ApiResponseGeneral<PaginatedResponse<Product>>
      >(this.URL_API + `/api/Supply/Paged`, { params: paramsAux })
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getSupplyOptionFilter(): Observable<any | null> {
    return this.http.get<any>(this.URL_API + `/api/Supply/PagedFilterOptions`, {}).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }
}
